import type { GetListingBannersData } from '@/shared/api/experience';
import { useExperienceApi } from '@/shared/api/useExperienceApi.ts';
import { useQuery } from '@tanstack/vue-query';
import type { Ref } from 'vue';

export const useListingBanners = (params: Ref<GetListingBannersData['query']>) => {
  const { getListingBanners } = useExperienceApi();
  const { data: bannersData } = useQuery({
    queryKey: ['getListingBanners', params],
    queryFn: async () => {
      const response = await getListingBanners({ query: { ...params.value } });

      return response.data;
    },
    retry: false,
  });

  return {
    bannersData,
  };
};
